import PropTypes from 'prop-types';

import { MEDIA_TYPES } from '@/common/constants';
import {
  ClassNameDefaultProps,
  ClassNamePropTypes,
} from '@/common/proptypes/Base/ClassName.protypes';

export const ModalItemDefaultProps = {
  ...ClassNameDefaultProps,
  alt: null,
  path: null,
  type: MEDIA_TYPES.IMAGE,
};

export const ModalItemPropTypes = {
  ...ClassNamePropTypes,
  alt: PropTypes.string,
  path: PropTypes.string,
  type: PropTypes.oneOf([MEDIA_TYPES.IMAGE, MEDIA_TYPES.VIDEO]),
};
